import styled from 'styled-components'
import Icon from '@/components/Icons'

export const Wrapper = styled.div`
  display: flex;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`
export const Image = styled.div`
  background-position: center center;
  background-size: cover;
  width: 144px;
  height: 116px;
  flex-shrink: 0;
  margin-right: 16px;

  @media (max-width: 768px) {
    margin-bottom: 16px;
  }
`

export const ItemHeading = styled.div<{ completed: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  font-weight: var(--font-bold);
  font-size: 16px;

  svg {
    display: ${({ completed }) => (completed ? 'block' : 'none')};
  }
`

export const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 15px;
  font-weight: var(--font-regular);
  font-size: 16px;

  &.total-row {
    align-items: flex-end;
  }
  > div {
    text-align: right;
  }
`
export const ItemRowLabel = styled.span`
  font-size: 14px;
  font-weight: var(--font-regular);
  color: var(--grey-100);
`

export const Title = styled.span`
  display: block;
  font-weight: var(--font-bold);
  line-height: 1.4;
  font-size: 18px;
`
export const ModalItem = styled.div<{ active: boolean }>`
  padding: 22px 20px;
  border: none;
  border-radius: 10px;
  -webkit-tap-highlight-color: transparent;
  position: relative;

  &.disabled {
    pointer-events: none;
    opacity: 0.7;
  }

  &:not(:last-child)::before {
    content: '';
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    bottom: -20px;
    height: 1px;
    width: 90%;
    border-bottom: 1px solid var(--grey-25);
  }
`
export const Edit = styled.span`
  font-size: 14px;
  font-weight: var(--font-medium);
  text-decoration: underline;
  cursor: pointer;
`
